/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DisplayBurnInRefreshTime_DisplayFragment = { __typename: 'Display', id: string, burnInRefreshSettings?: { __typename: 'BurnInRefreshSettingsState', reported: { __typename: 'BurnInRefreshSettings', time: string }, desired?: { __typename: 'BurnInRefreshSettings', time: string } | null } | null };

export type UpdateBurnInRefreshTimeMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateBurnInRefreshInput;
}>;


export type UpdateBurnInRefreshTimeMutation = { __typename: 'Mutation', displayBulkUpdateBurnInRefresh: { __typename: 'DisplayBulkUpdateBurnInRefreshPayload', displays: Array<{ __typename: 'Display', id: string, burnInRefreshSettings?: { __typename: 'BurnInRefreshSettingsState', reported: { __typename: 'BurnInRefreshSettings', time: string }, desired?: { __typename: 'BurnInRefreshSettings', time: string } | null } | null }> } };

export const DisplayBurnInRefreshTime_DisplayFragmentDoc = gql`
    fragment DisplayBurnInRefreshTime_display on Display {
  id
  burnInRefreshSettings {
    reported {
      time
    }
    desired {
      time
    }
  }
}
    `;
export const UpdateBurnInRefreshTimeDocument = gql`
    mutation updateBurnInRefreshTime($input: DisplayBulkUpdateBurnInRefreshInput!) {
  displayBulkUpdateBurnInRefresh(input: $input) {
    displays {
      id
      ...DisplayBurnInRefreshTime_display
    }
  }
}
    ${DisplayBurnInRefreshTime_DisplayFragmentDoc}`;
export type UpdateBurnInRefreshTimeMutationFn = ApolloReactCommon.MutationFunction<UpdateBurnInRefreshTimeMutation, UpdateBurnInRefreshTimeMutationVariables>;

/**
 * __useUpdateBurnInRefreshTimeMutation__
 *
 * To run a mutation, you first call `useUpdateBurnInRefreshTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBurnInRefreshTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBurnInRefreshTimeMutation, { data, loading, error }] = useUpdateBurnInRefreshTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBurnInRefreshTimeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBurnInRefreshTimeMutation, UpdateBurnInRefreshTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBurnInRefreshTimeMutation, UpdateBurnInRefreshTimeMutationVariables>(UpdateBurnInRefreshTimeDocument, options);
      }
export type UpdateBurnInRefreshTimeMutationHookResult = ReturnType<typeof useUpdateBurnInRefreshTimeMutation>;
export type UpdateBurnInRefreshTimeMutationResult = ApolloReactCommon.MutationResult<UpdateBurnInRefreshTimeMutation>;
export type UpdateBurnInRefreshTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBurnInRefreshTimeMutation, UpdateBurnInRefreshTimeMutationVariables>;